import React, { Component } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import moment from "moment"
import * as ReactQuill from "react-quill-v2.0"
import reggie from "../../../../../../../utilities/Reggie"
import snackBar from "../../../../../../../utilities/snackBar/SnackBar"
import IncidentAppointmentTypes from "../../../../../Types/IncidentAppointmentTypes"
import EditIncidentTypes from "../../../../../Types/EditIncidentTypes"
import ReferenceTypes from "../../../../../Types/ReferenceTypes"
import SupervisorTypes from "../../../../../Types/SupervisorTypes"
import AddIncidentAppointment from "./IncidentAppointments/AddIncidentAppointment/AddIncidentAppointment"
import EditIncidentAppointment from "./IncidentAppointments/EditIncidentAppointment/EditIncidentAppointment"
import ExpandedRichText from "../../../../../HRUtilities/ExpandedRichText/ExpandedRichText"
import IncidentChecklist from "./IncidentChecklist/IncidentChecklist"
import WorkCompReferenceTypes from "../../../../../Types/WorkCompReferenceTypes"
import AddSupervisor from "./IncidentSupervisors/AddSupervisor/AddSupervisor"
import DeleteSupervisors from "./IncidentSupervisors/DeleteSupervisors/DeleteSupervisors"

interface Props {
    incident: EditIncidentTypes | any
    userId: string | number
    setEventType: Function
    eventType: Function | any
    appendParams: Function
    timeFormat: string
    reference: ReferenceTypes
    workCompReference: WorkCompReferenceTypes
    saveIncident: Function
    isDirty: boolean
    loading: boolean
    getIncident: Function
    readOnly: boolean
}

interface State {
    addSupervisor: boolean
    deleteSupervisors: boolean
    addAppointment: boolean
    editAppointment: boolean
    expandDescription: boolean
    expandRestrictions: boolean
    descending: boolean
}

class IncidentDetails extends Component<Props, State> {

    editDex = -1

    formats = [
        "font", "color",
        "header",
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link"
    ]

    state = {
        addSupervisor: false,
        deleteSupervisors: false,
        addAppointment: false,
        editAppointment: false,
        expandDescription: false,
        expandRestrictions: false,
        descending: true
    }

    handleQuill = (event: any) => {
        let input = event
        let incident = this.props.incident
        let eventType = this.props.eventType
        let eventTypes = Object.keys(incident)
        let temp: any = incident
        if (reggie.filterTags(input) === "") {
            input = null
        }
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.props.appendParams([param])
            }
        }
    }

    closeQuill = () => {
        // this.props.saveIncident()
        this.setState({ expandDescription: false, expandRestrictions: false })
    }

    addSupervisors = (stagedSupervisors: Array<SupervisorTypes>) => {
        let temp = this.props.incident.Supervisors
        for (let i = 0; i < stagedSupervisors.length; i++) {
            temp.push(stagedSupervisors[i])
        }
        this.props.appendParams([{ Supervisors: temp }])
        this.setState({ addSupervisor: false })
        this.props.getIncident()
    }

    removeSupervisors = (stagedSupervisors: Array<SupervisorTypes>) => {
        let temp = this.props.incident.Supervisors
        for (let i = 0; i < stagedSupervisors.length; i++) {
            for (let j = temp.length - 1; j >= 0; --j) {
                if (temp[j].SupervisorId === stagedSupervisors[i].SupervisorId) {
                    temp.splice(j, 1);
                }
            }
        }
        this.props.appendParams([{ Supervisors: temp }])
        this.setState({ deleteSupervisors: false })
        this.props.getIncident()
    }

    addAppointment = (appointment: IncidentAppointmentTypes) => {
        let temp = this.props.incident.MedicalAppointments
        temp.push(appointment)
        this.props.appendParams([{ MedicalAppointments: temp }])
        this.setState({ addAppointment: false })
        this.props.getIncident()
    }

    editAppointment = (appointment: IncidentAppointmentTypes) => {
        let temp = this.props.incident.MedicalAppointments
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].IncidentMedicalAppointmentId === appointment.IncidentMedicalAppointmentId) {
                temp[i] = appointment
            }
        }
        this.props.appendParams([{ MedicalAppointments: temp }])
        this.setState({ editAppointment: false })
        this.props.getIncident()
    }

    removeAppointment = (appointment: IncidentAppointmentTypes) => {
        let temp = this.props.incident.MedicalAppointments
        for (let i = temp.length - 1; i >= 0; --i) {
            if (temp[i].IncidentMedicalAppointmentId === appointment.IncidentMedicalAppointmentId) {
                temp.splice(i, 1);
            }
        }
        this.props.appendParams([{ MedicalAppointments: temp }])
        this.setState({ editAppointment: false })
        this.props.getIncident()
    }

    emailSupervisors = () => {
        let mailString = "mailto:"
        for (let i = 0; i < this.props.incident.Supervisors.length; i++) {
            if (reggie.validateMail(this.props.incident.Supervisors[i].SupervisorEmail || "")) {
                mailString += `${this.props.incident.Supervisors[i].SupervisorEmail};`
            }
        }
        mailString = mailString.substring(0, mailString.length - 1);
        window.open(mailString)
    }

    emailSupervisor = (supervisor: SupervisorTypes) => {
        navigator.clipboard.writeText(supervisor.SupervisorEmail)
        window.open(`mailto:${supervisor.SupervisorEmail}`)
        snackBar({ text: "Email copied to clipboard", type: "success", timeout: 4000 })
    }

    callSupervisor = (supervisor: SupervisorTypes) => {
        navigator.clipboard.writeText(supervisor.SupervisorPhone)
        window.open(`tel:${supervisor.SupervisorPhone}`)
        snackBar({ text: "Phone number copied to clipboard", type: "success", timeout: 4000 })
    }

    toggleModal = (key: string, editDex?: number) => {
        let state: any = this.state
        if (!state[key]) {
            state[key] = true
        } else {
            state[key] = false
        }
        if (editDex || editDex === 0/*zero isnt truthy in JS*/) {
            this.editDex = editDex
        } else {
            this.editDex = -1
        }
        this.setState(state)
    }

    toggleSort = () => {
        this.setState({ descending: !this.state.descending })
    }

    sortMedicalAppointments = () => {
        let appointments = this.props.incident.MedicalAppointments
        if (this.state.descending) {
            return appointments.sort((a: any, b: any) => (a.AppointmentDateUTC < b.AppointmentDateUTC) ? 1 : -1)
        }
        return appointments.sort((a: any, b: any) => (a.AppointmentDateUTC > b.AppointmentDateUTC) ? 1 : -1)
    }

    render() {

        const props = this.props
        const incident = props.incident
        const readOnly = props.readOnly
        if (incident.MedicalAppointments) {
            incident.MedicalAppointments = this.sortMedicalAppointments()
        }
        let pillType = "Raised"
  
        const IncidentDetailsTooltip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text}
            </Tooltip>
        )

        return (
            <div className="IncidentDetails">
                <div className={`IncidentDetailsAccordionContent${pillType}`}>
                    <div className="IncidentDetailsAccordionContentLeft">
                        <div className={`IncidentDetailsColumn${pillType}`} id="IncidentDescription">
                        <div className={`IncidentDetailsColumnTitleWrapper${pillType}`}>
                                <p className="IncidentDetailsColumnTitle">Description</p>
                                <span className="material-icons">description</span>
                                <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Expand editor")}>
                                    <span id="incident-rich-text-modal-btn" className="material-icons" onClick={() => this.toggleModal("expandDescription")}>open_in_full</span>
                                </OverlayTrigger>
                            </div>
                            {/*@ts-ignore*/}
                            {!this.state.expandDescription && <ReactQuill
                                value={incident.IncidentDescription}
                                onFocus={() => this.props.setEventType("IncidentDescription")}
                                onChange={this.handleQuill}
                                formats={this.formats}
                                readOnly={readOnly}
                            />}
                        </div>
                        <div className={`IncidentDetailsColumn${pillType}`} id="incident-restrictions-column">
                            <div id={`RestrictionsDescription${pillType}`}>
                                <div className={`IncidentDetailsColumnTitleWrapper${pillType}`}>
                                    <p className="IncidentDetailsColumnTitle">Restrictions</p>
                                    <span className="material-icons">remove_circle_outline</span>
                                    <div id="incident-has-restrictions-btn-wrapper">
                                        <div className="RestrictionTypeBtnWrapper" id="Restrictions">
                                            <div className="RestrictionTypeBtn" onClick={() => this.props.appendParams([{ Restrictions: true }])}>
                                                <p>Yes</p>
                                                {incident.Restrictions && <div className="RestrictionTypeBtnCustomRadioChecked"></div>}
                                                {!incident.Restrictions && <div className="RestrictionTypeBtnCustomRadioUnchecked"></div>}
                                            </div>
                                            <div className="RestrictionTypeBtn" onClick={() => this.props.appendParams([{ Restrictions: null }])}>
                                                <p>No</p>
                                                {!incident.Restrictions && <div className="RestrictionTypeBtnCustomRadioChecked"></div>}
                                                {incident.Restrictions && <div className="RestrictionTypeBtnCustomRadioUnchecked"></div>}
                                            </div>
                                        </div>
                                    </div>
                                    <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Expand editor")}>
                                        <span id="incident-rich-text-modal-btn" className="material-icons" onClick={() => this.toggleModal("expandRestrictions")}>open_in_full</span>
                                    </OverlayTrigger>
                                </div>
                                {/*@ts-ignore*/}
                                {!this.state.expandRestrictions && <ReactQuill
                                    value={incident.RestrictionsDescription}
                                    onFocus={() => this.props.setEventType("RestrictionsDescription")}
                                    onChange={this.handleQuill}
                                    formats={this.formats}
                                    readOnly={readOnly}
                                />}
                            </div>
                            <div id="incident-restrictions-column-bottom">
                                <div id="incident-restrictions-column-bottom-radio-btn-wrapper">
                                    <p id={`incident-restrictions-column-bottom-radio-btn-wrapper-text-${pillType.toLowerCase()}`}>Medical Treatment?</p>
                                    <div className="RestrictionTypeBtnWrapper" id="MedicalTreatment">
                                        <div className="RestrictionTypeBtn" onClick={() => this.props.appendParams([{ MedicalTreatment: true }])}>
                                            <p>Yes</p>
                                            {incident.MedicalTreatment && <div className="RestrictionTypeBtnCustomRadioChecked"></div>}
                                            {!incident.MedicalTreatment && <div className="RestrictionTypeBtnCustomRadioUnchecked"></div>}
                                        </div>
                                        <div className="RestrictionTypeBtn" onClick={() => this.props.appendParams([{ MedicalTreatment: null }])}>
                                            <p>No</p>
                                            {!incident.MedicalTreatment && <div className="RestrictionTypeBtnCustomRadioChecked"></div>}
                                            {incident.MedicalTreatment && <div className="RestrictionTypeBtnCustomRadioUnchecked"></div>}
                                        </div>
                                    </div>
                                </div>
                                <div id="incident-restrictions-column-bottom-radio-btn-wrapper">
                                    <p id={`incident-restrictions-column-bottom-radio-btn-wrapper-text-${pillType.toLowerCase()}`}>OSHA Recordable?</p>
                                    <div className="RestrictionTypeBtnWrapper" id="OshaRecordable">
                                        <div className="RestrictionTypeBtn" onClick={() => this.props.appendParams([{ OshaRecordable: true }])}>
                                            <p>Yes</p>
                                            {incident.OshaRecordable && <div className="RestrictionTypeBtnCustomRadioChecked"></div>}
                                            {!incident.OshaRecordable && <div className="RestrictionTypeBtnCustomRadioUnchecked"></div>}
                                        </div>
                                        <div className="RestrictionTypeBtn" onClick={() => this.props.appendParams([{ OshaRecordable: null }])}>
                                            <p>No</p>
                                            {!incident.OshaRecordable && <div className="RestrictionTypeBtnCustomRadioChecked"></div>}
                                            {incident.OshaRecordable && <div className="RestrictionTypeBtnCustomRadioUnchecked"></div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="IncidentDetailsAccordionContentMiddle">
                        <div className={`IncidentDetailsColumn${pillType}`} id="incident-supervisors-column">
                        <div className={`IncidentDetailsColumnTitleWrapper${pillType}`}>
                                <p className="IncidentDetailsColumnTitle">Supervisors</p>
                                <span className="material-icons">supervised_user_circle</span>
                                {incident.Supervisors && incident.Supervisors.length > 0 && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Delete Supervisors")}>
                                    <span id="incident-supervisors-column-delete-supervisors-btn" className="material-icons" onClick={() => this.toggleModal("deleteSupervisors")}>delete</span>
                                </OverlayTrigger>}
                                {!readOnly && <div id="incident-supervisors-column-right-btn-wrapper">
                                    {incident.Supervisors && incident.Supervisors.length > 0 && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Email Supervisors")}>
                                        <span id="incident-supervisors-column-email-all-supervisors-btn" className="material-icons" onClick={() => this.emailSupervisors()}>forward_to_inbox</span>
                                    </OverlayTrigger>}
                                    <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Add Supervisors")}>
                                        <span id="incident-supervisors-column-add-supervisor-btn" className="material-icons" onClick={() => this.toggleModal("addSupervisor")}>add</span>
                                    </OverlayTrigger>
                                </div>}
                            </div>
                            <div id="incident-supervisors-column-supervisor-list">
                                {incident.Supervisors && incident.Supervisors.map((supervisor: SupervisorTypes | any, i: number) =>
                                    <div className="IncidentSupervisorColumnSupervisor" key={supervisor.IncidentSupervisorId || i}>
                                        <div className="IncidentSupervisorColumnSupervisorName">
                                            <p>{supervisor.SupervisorDisplayName}</p>
                                        </div>
                                        {reggie.validatePhone(supervisor.SupervisorPhone) && <div className="IncidentSupervisorColumnSupervisorPhone">
                                            <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={IncidentDetailsTooltip(supervisor.SupervisorPhone)}>
                                                <span className="material-icons" onClick={() => this.callSupervisor(supervisor)}>phone</span>
                                            </OverlayTrigger>
                                        </div>}
                                        {!reggie.validatePhone(supervisor.SupervisorPhone) && <div className="IncidentSupervisorColumnSupervisorPhone">
                                            <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={IncidentDetailsTooltip("Invalid Phone")}>
                                                <span id="incident-supervisors-column-supervisor-list-invalid-phone" className="material-icons" onClick={() => this.callSupervisor(supervisor)}>report_gmailerrorred</span>
                                            </OverlayTrigger>
                                        </div>}
                                        {reggie.validateMail(supervisor.SupervisorEmail) && <div className="IncidentSupervisorColumnSupervisorMail">
                                            <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={IncidentDetailsTooltip(supervisor.SupervisorEmail)}>
                                                <span className="material-icons" onClick={() => this.emailSupervisor(supervisor)}>email</span>
                                            </OverlayTrigger>
                                        </div>}
                                        {!reggie.validateMail(supervisor.SupervisorEmail) && <div className="IncidentSupervisorColumnSupervisorMail">
                                            <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={IncidentDetailsTooltip("Invalid Email")}>
                                                <span id="incident-supervisors-column-supervisor-list-invalid-email" className="material-icons" onClick={() => this.emailSupervisor(supervisor)}>report_gmailerrorred</span>
                                            </OverlayTrigger>
                                        </div>}
                                    </div>
                                )}
                                {incident.Supervisors && incident.Supervisors.length === 0 && <div className="IncidentSupervisorColumnSupervisorEmpty">
                                    <p>No supervisors added</p>
                                </div>}
                            </div>
                        </div>
                        <div className={`IncidentDetailsColumn${pillType}`} id="incident-appointments-column">
                        <div className={`IncidentDetailsColumnTitleWrapper${pillType}`}>
                                <p className="IncidentDetailsColumnTitle">Medical Appts</p>
                                <span className="material-icons">medical_services</span>
                                {!readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Add Appointments")}>
                                    <span id="incident-appointments-column-add-appointments-btn" className="material-icons" onClick={() => this.toggleModal("addAppointment")}>add</span>
                                </OverlayTrigger>}
                                <div className="IncidentDetailsSortMedicalAppointemnts">
                                    {this.state.descending && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={IncidentDetailsTooltip("Sort Ascending")}>
                                        <div className="WorkCompSortItems" onClick={() => this.toggleSort()}>
                                            <span id="work-comp-sort-asc" className="material-icons">sort</span>
                                        </div>
                                    </OverlayTrigger>}
                                    {!this.state.descending && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={IncidentDetailsTooltip("Sort Descending")}>
                                        <div className="WorkCompSortItems" onClick={() => this.toggleSort()}>
                                            <span id="work-comp-sort-desc" className="material-icons">sort</span>
                                        </div>
                                    </OverlayTrigger>}
                                </div>
                            </div>
                            {incident.MedicalAppointments && <div id="incident-appointments-column-appointment-list">
                                {incident.MedicalAppointments.length > 0 && incident.MedicalAppointments.map((appointment: IncidentAppointmentTypes, i: number) =>
                                    <OverlayTrigger key={i} delay={{ show: 0, hide: 0 }} placement="top" overlay={IncidentDetailsTooltip("Edit Appointemnet")}>
                                        <div className="IncidentAppointmentColumnAppointment" onClick={() => this.toggleModal("editAppointment", i)}>
                                            <p id="incident-appointment-date">{moment(appointment.AppointmentDateUTC).format(this.props.timeFormat)}</p>
                                            <p id="incident-appointment-description">{appointment.AppointmentDesc}</p>
                                        </div>
                                    </OverlayTrigger>
                                )}
                                {incident.MedicalAppointments.length === 0 && <div className="IncidentAppointmentColumnNoAppointments">
                                    <p>No Appointments</p>
                                </div>}
                            </div>}
                        </div>
                    </div>
                    <div className="IncidentDetailsAccordionContentRight">
                        {incident.WorkersCompensationIncidentId && <div className={`IncidentDetailsColumn${pillType}`} id="incident-checklist-column">
                            <IncidentChecklist
                                contextUserId={this.props.userId}
                                WorkersCompensationIncidentId={incident.WorkersCompensationIncidentId}
                                IncidentTypeId={incident.IncidentTypeId}
                                workCompReference={this.props.workCompReference}
                                readOnly={readOnly}
                            />
                        </div>}
                    </div>
                </div>
                {this.state.expandDescription &&
                    <ExpandedRichText
                        type="Description"
                        eventKey="IncidentDescription"
                        toggleKey="expandDescription"
                        text={incident.IncidentDescription}
                        setEventType={this.props.setEventType}
                        handleQuill={this.handleQuill}
                        // saveIncident={this.closeQuill}
                        toggleEditor={this.toggleModal}
                        dirty={this.props.isDirty}
                    // saving={this.props.loading}
                    />}
                {this.state.expandRestrictions &&
                    <ExpandedRichText
                        type="Restrictions"
                        eventKey="RestrictionsDescription"
                        toggleKey="expandRestrictions"
                        text={incident.RestrictionsDescription}
                        setEventType={this.props.setEventType}
                        handleQuill={this.handleQuill}
                        // saveIncident={this.closeQuill}
                        toggleEditor={this.toggleModal}
                        dirty={this.props.isDirty}
                    // saving={this.props.loading}
                    />}
                {this.state.addSupervisor &&
                    <AddSupervisor
                        toggleAddSupervisor={() => this.toggleModal("addSupervisor")}
                        appendParams={this.props.appendParams}
                        reference={this.props.reference}
                        incident={incident}
                        userId={this.props.userId}
                        updateSupervisors={this.addSupervisors}
                    />}
                {this.state.deleteSupervisors &&
                    <DeleteSupervisors
                        toggleDeleteSupervisors={() => this.toggleModal("deleteSupervisors")}
                        appendParams={this.props.appendParams}
                        reference={this.props.reference}
                        incident={incident}
                        userId={this.props.userId}
                        removeSupervisors={this.removeSupervisors}
                        readOnly={readOnly}
                    />}

                {this.state.addAppointment &&
                    <AddIncidentAppointment
                        toggleAddAppointment={() => this.toggleModal("addAppointment")}
                        addAppointment={this.addAppointment}
                        IncidentId={incident.WorkersCompensationIncidentId}
                        timeFormat={this.props.timeFormat}
                        userId={this.props.userId}
                    />}
                {this.state.editAppointment && this.editDex > -1 &&
                    <EditIncidentAppointment
                        toggleEditAppointment={() => this.toggleModal("editAppointment")}
                        editAppointment={this.editAppointment}
                        removeAppointment={this.removeAppointment}
                        IncidentId={incident.WorkersCompensationIncidentId}
                        timeFormat={this.props.timeFormat}
                        userId={this.props.userId}
                        appointment={incident.MedicalAppointments[this.editDex]}
                        readOnly={readOnly}
                    />}
            </div>
        )
    }
}

export default IncidentDetails;